import { CLASSROOM_MODULE_CREATE_FOLDER } from '../actions';
import { createFolder as createFolderApi } from '../api';
import toFolder from '../api/toFolder';
import { MATERIAL_UNTITLED_SECTION } from '../constants';
import { topLevelMaterials } from '../selectors';
import { currentClassRoomId } from '../../selectors/classroom';
import { openRenameFolder } from './openCloseRenameFolder.operation';

const isFolder = (item) => item.isFolder;
const isUntitledFolder = (item) => {
  const { title } = item;
  return isFolder(item) && title.startsWith(MATERIAL_UNTITLED_SECTION);
};

const isUniqueTitleIn = (a, title) => !a.some((item) => item.title === title);

const getOrder = (item) => parseFloat(item.order);

const createFolder = (status, payload) => ({
  type: CLASSROOM_MODULE_CREATE_FOLDER,
  status,
  payload,
});

const createFolderStarted = createFolder.bind(null, 'started');
const createFolderSuccess = createFolder.bind(null, 'success');
const createFolderError = createFolder.bind(null, 'error');

const createFolderOperation = (educatorOnly) => async (dispatch, getState) => {
  const state = getState();
  const topLevel = topLevelMaterials(state);
  const topLevelUntitled = topLevel.filter(isUntitledFolder);

  let title = MATERIAL_UNTITLED_SECTION;
  let i = 1;
  while (!isUniqueTitleIn(topLevelUntitled, title)) {
    title = `${MATERIAL_UNTITLED_SECTION} (${i})`;
    i += 1;
  }

  const folder = {
    title,
    hidden: !educatorOnly,
    educatorOnly,
  };

  const localId = `local.${Date.now()}`;
  const classRoomId = currentClassRoomId(state);
  const maxOrder = Math.max(
    ...(topLevel.length ? topLevel.map(getOrder) : [5])
  );

  dispatch(
    createFolderStarted({
      folder: toFolder({
        ...folder,
        id: localId,
        // note that this order is *only* used while we're waiting for the
        // backend's response we don't pass it to the request and the server is
        // written in a way that makes it append if we don't specify the order
        order: String((maxOrder + 10) / 2),
        space: classRoomId,
      }),
    })
  );

  try {
    const savedFolder = await createFolderApi(classRoomId, folder, localId);
    dispatch(openRenameFolder(localId));
    await dispatch(
      createFolderSuccess({
        localId,
        folder: savedFolder,
      })
    );
    dispatch(openRenameFolder(savedFolder.id));
  } catch (error) {
    dispatch(
      createFolderError({
        localId,
        error,
      })
    );
  }
};

export default createFolderOperation;
